import React from "react";
import { RenderOnlyFor, isSummaryPage } from "@ignitesales/neuro-application";
import BasicFooter from "../../../../../../../shared/js/core-components/BasicFooter.jsx";
import SummaryActionButtons from "../../../../../../../shared/js/core-components/ContactShareButtons";
import {
    SummaryPageSubtitle,
    SummaryPageTitle,
} from "../../../../../../../shared/js/core-components/ProductPageMessages";
import { useThemeSettings } from "../../../../../../../shared/js/hooks/useThemeSettings.mjs";
import classnames from "classnames";
import {
    productComponentClass,
    DialogueProductWrapper,
} from "../../../../../../../shared/js/core-components/DialogueProductWrapper";
import { CollapsibleAnswersList } from "../../../../../../../shared/js";
import ReturnToSurveyButton from "../../../../../../../shared/js/core-components/ReturnToSurveyButton";
import ActionButtonContainer from "../../../../../../../shared/js/core-components/ActionButtonContainer";
import useRecommendedProductActionTrigger from "../../../../../../../shared/js/hooks/useRecommendedProductActionTrigger.mjs";
import { useDialogueGuideSettings } from '../../../../../../../shared/js/hooks/useDialogueGuideSettings.mjs';

function SummaryPage({ componentClass, productsList }) {
    const { getSummaryThemeConfigs } = useThemeSettings();
    const { productLayout, productStyle } = getSummaryThemeConfigs();
    const themeUseSidebar = getSummaryThemeConfigs().useSidebar;
    const useSidebar = themeUseSidebar && window.innerWidth >= 1024;
    useRecommendedProductActionTrigger(productsList);
    const { showEditAnswers } = useDialogueGuideSettings();

    const classes = classnames(componentClass, {
        [`${componentClass}--noSidebar`]: !useSidebar,
    });
    const productClasses = classnames({
        [`${productComponentClass}--fullRowProduct`]:
            productLayout === "single", //config for productLayout
        [`${productComponentClass}--style2`]: productStyle === 2, //config for productStyle
        [`${productComponentClass}--style3`]: productStyle === 3, //config for productStyle
    });

    const summaryPageHeader = (
        <div className={`${componentClass}__header`}>
            <div>
                <SummaryPageTitle />
                <SummaryPageSubtitle />
            </div>
            <div className="header-buttons">
                <RenderOnlyFor forSummaryPage={true} forDetailsPage={true}>
                    <SummaryActionButtons />
                </RenderOnlyFor>
                <RenderOnlyFor forSummaryPage={true}>
                    <ActionButtonContainer
                        position="top"
                        page="SummaryPage"
                    ></ActionButtonContainer>
                </RenderOnlyFor>
            </div>
        </div>
    );

    return (
        <div className={classes} id={componentClass}>
            <div className="container">
                {!useSidebar && summaryPageHeader}
                <div className={`${componentClass}__products`}>
                    {productsList.map((p) => (
                        <DialogueProductWrapper
                            key={p.id}
                            product={p}
                            className={productClasses}
                        />
                    ))}
                </div>
                <div className={`${componentClass}__actions`}>
                    <RenderOnlyFor forSummaryPage={true}>
                        <ActionButtonContainer
                            position="bottom"
                            page="SummaryPage"
                        ></ActionButtonContainer>
                    </RenderOnlyFor>
                </div>
                <CollapsibleAnswersList
                    className={`${componentClass}__answers`}
                    shouldLinkToQuestion={showEditAnswers}
                />
                <ReturnToSurveyButton
                    className={`${componentClass}__navigation`}
                />
            </div>
            <BasicFooter />
        </div>
    );
}

export default SummaryPage;
